import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import { stealCapturedURLParams } from "../../Browser/CapturedURLParams";

const REDIRECT_RESULT_TO_ERROR_TYPE: { [key: string]: string } = {
  ponto_connection_failed: "ponto_connection_failed",
  bank_connection_failed: "bank_connection_failed",
  error: "ponto_oauth_error",
};

class PaymentsWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.setState({
      ...this.component.state,
      ...this.component.props.app.dashboardPaymentsFilterCheckBoxState
    }, () => {
      this.component.props.dispatch({
        type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
      });

      const selectedFilterBankAccount = "all";

      this.component.paginatorPath = `Dashboard_Payments_${selectedFilterBankAccount}`;

      const result = stealCapturedURLParams("result");
      const description = stealCapturedURLParams("description");
      let pontoRedirectError: { type: string, description: string | null } | null = null;

      if (result) {
        this.component.props.dispatch({ type: Constants.GLOBAL_PONTO_INTEGRATION_GET });
      }

      if (result === "ponto_connection_success") {
        this.component.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.component.trans("ponto_redirect_success"),
            type: "success"
          }
        });
      } else if (REDIRECT_RESULT_TO_ERROR_TYPE[result]) {
        pontoRedirectError = {
          type: REDIRECT_RESULT_TO_ERROR_TYPE[result],
          description
        };
      }

      if (result && typeof window !== "undefined" && window.history) {
        window.history.replaceState(null, "", window.location.pathname);
      }

      this.component.setState({
        filter: "unused",
        agencyBankAccountId: "all",
        filterValue: "",
        isPaymentUlinkPopupOpen: false,
        isPaymentRemovePopupOpen: false,
        isSaving: false,
        paymentDelete: null,
        isPaymentCheckToSettle: false,
        isPaymentUnSettlePopupOpen: false,
        unSettlePayment: null,
        dateFilter: undefined,
        pontoRedirectError
      }, () => {

        this.component.fetchFirstUnusedPayments(() => {
          window.scrollTo({
            top: this.component.props.app?.dashboardPaymentsListPosition
          });
        });
      });
    })
  }
}

export default new PaymentsWillMount();
